/**
 * FairwayBid – Richtigstellungen an Console-Texten
 *
 * Grundsatz: Die Texte gehören in die Console, nicht in den Code. Diese
 * Datei ist die Ausnahme für einen Fall – wenn ein Console-Text dem Produkt
 * widerspricht und bis zur Korrektur live wäre.
 *
 * Der Fall: Auf "So funktioniert es" stand unter "Was es kostet", Händler
 * zahlten erst bei einem Geschäft und es gebe keine Grundgebühr. Das ist das
 * Provisionsmodell, das zurückgestellt wurde. Zwei Bildschirmhöhen weiter
 * stehen auf derselben Seite die Monatspreise – zwei Aussagen, die sich
 * ausschließen. Für einen Händler ist das die Frage, ob er zahlen muss;
 * für einen Investor die Frage, ob wir unser eigenes Modell kennen.
 *
 * Die Ersetzung greift über den Anfang des Satzes. Sobald Tom den Absatz in
 * der Console korrigiert, passt das Muster nicht mehr und hier passiert
 * nichts – die Datei heilt sich selbst, statt zur zweiten Wahrheit zu werden.
 *
 * Reine Zeichenkettenarbeit, kein React – damit prüfbar.
 */

export const TEXT_FIXES = [
  {
    // Gilt nur im Abschnitt "Was es kostet" auf "So funktioniert es".
    sectionId: 'kosten',
    beginntMit: 'Händler zahlen erst, wenn ein Geschäft zustande kommt',
    ersatz:
      'Händler und Hersteller zahlen eine monatliche Mitgliedschaft: Basis kostenlos, Professional und Premium mit größerem Angebotskontingent und Zeitvorsprung bei neuen Anfragen. Keine Provision auf Ihre Umsätze, kein Listungsentgelt, keine Klickpreise. Monatlich kündbar.',
  },
];

/**
 * Absätze, die nicht mehr gebraucht werden.
 *
 * "Drei Dinge, die für alle Pakete gelten." stand als Einleitung über einer
 * Aufzählung, die die drei Dinge selbst zeigt - der Satz kündigt an, was
 * direkt darunter steht. Gleiche Regel wie oben: Sobald er in der Console
 * weg ist, greift hier nichts mehr.
 */
export const TEXT_DROPS = [{ sectionId: 'mitgliedschaft-details', beginntMit: 'Drei Dinge, die' }];

export const istWegzulassen = (absatz, sectionId) =>
  TEXT_DROPS.some(
    d =>
      d.sectionId === sectionId &&
      String(absatz || '')
        .trim()
        .startsWith(d.beginntMit)
  );

/**
 * Ersetzt einen Absatz, wenn er auf eine Richtigstellung passt.
 *
 * @param {string} absatz Absatz aus der Console
 * @param {string} sectionId Abschnitt, aus dem er stammt
 * @returns {string} korrigierter oder unveränderter Absatz
 */
export const fixAbsatz = (absatz, sectionId) => {
  const text = String(absatz || '');
  const fix = TEXT_FIXES.find(
    f => f.sectionId === sectionId && text.trim().startsWith(f.beginntMit)
  );
  return fix ? fix.ersatz : text;
};
